import React from 'react';
import { observer } from 'mobx-react-lite';

import { COOKIE_DISPLAY_MODE } from '@ratehub/base-ui';
import { LifeInsuranceWizard } from '@ratehub/ins-life-wizard';

import Layout from './Layout';


function LifeQuotesPage({ ...otherProps }) {
    return (
        <Layout
            hideBackgroundImage
            isGridDisabled
            cookiePromptDisplay={COOKIE_DISPLAY_MODE.MODAL}
        >
            <LifeInsuranceWizard
                {...otherProps}
            />
        </Layout>
    );
}

export default observer(LifeQuotesPage);
